'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import {
    SET_FUNCTIONS_USERS_BY_PROFILE,
    GET_DATA_USERS_BY_PROFILE_START,
    GET_DATA_USERS_BY_PROFILE_SUCCESS,
    SEARCH_USER_USERS_BY_PROFILE,
    SET_ACTIVOS_CHECKBOX_USERS_BY_PROFILE,
    SET_BLOQUEADOS_CHECKBOX_USERS_BY_PROFILE,
    SET_ELIMINADOS_CHECKBOX_USERS_BY_PROFILE,
    SET_ALL_CHECKBOX_USERS_BY_PROFILE,
    FILTER_ORDER_COLUMN_USERS_BY_PROFILE,
    FILTER_CHECKBOX_USERS_BY_PROFILE,
    INITIAL_STATE_USUARIOS_PERFIL,
    SET_TITLE_USERS_BY_PROFILE
} from '../../Screens/UsuariosPorPerfil/actions/UsuariosPorPerfil';

const initialState = {
    currentUser: null,
    isFetching: true,
    title2 : undefined,
    functions: [],
    usuarios: undefined,
    usuariosFiltrados: undefined,
    usuariosSeleccionados: [],
    searchFilter: "",
    activoFilter: true,
    bloqueadoFilter: true,
    eliminadoFilter: true,
    allCheckboxFilter: false,
    column: [{ "name": "nombre", "state": false }, { "name": "login", "state": true }, { "name": "sucursal", "state": true }, { "name": "sector", "state": true }],
    columnIndex: 0,
    isCurrentUser: undefined
};

function usuariosPorPerfil(state = initialState, action) {
    LogHelper.In(usuariosPorPerfil.name, state, action);

    let result;
    let usuariosFiltrados, usuariosTemp, temp = null;
    let usuariosSeleccionadosTemp = [];

    switch (action.type) {

        case SET_FUNCTIONS_USERS_BY_PROFILE:
            LogHelper.In(usuariosPorPerfil.name, state, action);

            result = {
                ...state,
                functions: action.functions
            };
            break;

        case GET_DATA_USERS_BY_PROFILE_START:
            LogHelper.In(usuariosPorPerfil.name, state, action);

            result = {
                ...state,
                currentUser: action.currentUser,
                currentUserLogin : action.currentUserLogin,
                isFetching: true
            };
            break;

        case GET_DATA_USERS_BY_PROFILE_SUCCESS:
            LogHelper.In(usuariosPorPerfil.name, state, action);

            let tempResult = action.result;
            tempResult.forEach(p => { p.Seleccionado = false; });

            result = {
                ...state,
                isFetching: false,
                usuarios: tempResult,
                usuariosFiltrados: tempResult,
                usuariosSeleccionados: []
            };
            break;

        case SET_TITLE_USERS_BY_PROFILE:
            LogHelper.In(usuariosPorPerfil.name, state, action);

            let _title2 = action._title2[0].Codigo;

            result = {
                ...state,
                title2 : _title2
            };

            break;

        case SEARCH_USER_USERS_BY_PROFILE:
            LogHelper.In(usuariosPorPerfil.name, state, action);

            usuariosFiltrados = usuariosFilter(state, action.user, null, null, null, null, null, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                searchFilter: action.user
            };
            break;

        case SET_ACTIVOS_CHECKBOX_USERS_BY_PROFILE:
            LogHelper.In(usuariosPorPerfil.name, state, action);

            usuariosFiltrados = usuariosFilter(state, null, action.activo, null, null, null, null, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                activoFilter: action.activo
            };
            break;

        case SET_BLOQUEADOS_CHECKBOX_USERS_BY_PROFILE:
            LogHelper.In(usuariosPorPerfil.name, state, action);

            usuariosFiltrados = usuariosFilter(state, null, null, action.bloqueado, null, null, null, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                bloqueadoFilter: action.bloqueado
            };
            break;

        case SET_ELIMINADOS_CHECKBOX_USERS_BY_PROFILE:
            LogHelper.In(usuariosPorPerfil.name, state, action);

            usuariosFiltrados = usuariosFilter(state, null, null, null, action.eliminado, null, null, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                eliminadoFilter: action.eliminado
            };
            break;

        case FILTER_ORDER_COLUMN_USERS_BY_PROFILE:
            LogHelper.In(usuariosPorPerfil.name, state, action);

            let columnTemp = JSON.parse(JSON.stringify(state.column));
            columnTemp[action.columnIndex].state = !columnTemp[action.columnIndex].state;

            usuariosFiltrados = usuariosFilter(state, null, null, null, null, action.columnIndex, columnTemp, null);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                columnIndex: action.columnIndex,
                column: columnTemp
            };
            break;

        case SET_ALL_CHECKBOX_USERS_BY_PROFILE:
            LogHelper.In(usuariosPorPerfil.name, state, action);

            let usuariosTemp = JSON.parse(JSON.stringify(state.usuarios));
            let usuariosSeleccionadosTemp = JSON.parse(JSON.stringify(state.usuariosSeleccionados));

            if (action.allCheckboxFilter == true) {
                usuariosTemp.forEach(function (item) {
                    if (action.currentUser != item.Id)
                        usuariosSeleccionadosTemp.push(item);
                })
            } else {
                usuariosSeleccionadosTemp = [];
            }

            usuariosFiltrados = usuariosFilter(state, null, null, null, null, null, null, usuariosSeleccionadosTemp);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                usuariosSeleccionados: usuariosSeleccionadosTemp,
                allCheckboxFilter: action.allCheckboxFilter
            };
            break;

        case FILTER_CHECKBOX_USERS_BY_PROFILE:
            LogHelper.In(usuariosPorPerfil.name, state, action);

            usuariosTemp = JSON.parse(JSON.stringify(state.usuarios));
            usuariosSeleccionadosTemp = JSON.parse(JSON.stringify(state.usuariosSeleccionados));

            let temp = usuariosSeleccionadosTemp.find(x => x.Id == action.usuarioId);
            if (temp != undefined) {
                usuariosSeleccionadosTemp.forEach(function (item, index, object) {
                    if (item.Id == action.usuarioId)
                        object.splice(index, 1);
                })
            } else {
                usuariosTemp.forEach(function (item) {
                    if (item.Id == action.usuarioId)
                        usuariosSeleccionadosTemp.push(item);
                })
            }

            usuariosFiltrados = usuariosFilter(state, null, null, null, null, null, null, usuariosSeleccionadosTemp);

            result = {
                ...state,
                usuariosFiltrados: usuariosFiltrados,
                usuariosSeleccionados: usuariosSeleccionadosTemp
            };
            break;

        case INITIAL_STATE_USUARIOS_PERFIL:
            result = initialState;
            break;

        default:
            LogHelper.In(usuariosPorPerfil.name, state, action);
            result = {
                ...state
            }
            break;
    }

    LogHelper.Out(usuariosPorPerfil.name, result);
    return result;
}

export default usuariosPorPerfil;



/**
 * Funcion general de filtrado que realiza (busqueda por nombre, por filtros y ordenamiento de columnas ascendente y descendente).
 * @param {any} state
 * @param {any} searchFilter
 * @param {any} activoFilter
 * @param {any} bloqueadoFilter
 * @param {any} eliminadoFilter
 * @param {any} columnIndex
 * @param {any} column
 * @param {any} usuariosSeleccionados
 */
function usuariosFilter(state, searchFilter, activoFilter, bloqueadoFilter, eliminadoFilter, columnIndex, column, usuariosSeleccionados) {
    LogHelper.In(usuariosFilter.name);

    //Obtengo valores y si no los recibi por parametro uso los que ya existen en el state.
    let usuariosFiltrados = JSON.parse(JSON.stringify(state.usuarios));

    searchFilter = searchFilter != null ? searchFilter : state.searchFilter;
    activoFilter = activoFilter != null ? activoFilter : state.activoFilter;
    bloqueadoFilter = bloqueadoFilter != null ? bloqueadoFilter : state.bloqueadoFilter;
    eliminadoFilter = eliminadoFilter != null ? eliminadoFilter : state.eliminadoFilter;
    columnIndex = columnIndex != null ? columnIndex : state.columnIndex;
    column = column != null ? column : state.column;
    usuariosSeleccionados = usuariosSeleccionados != null ? usuariosSeleccionados : state.usuariosSeleccionados;

    //Filtro por nombre de usuario.
    if (searchFilter != "")
        usuariosFiltrados = usuariosFiltrados.filter(x => x.Nombre.toUpperCase().includes(searchFilter.toUpperCase()) || x.Login.toUpperCase().includes(searchFilter.toUpperCase()));

    //Filtro por checkboxes de Activo, Bloqueado, Eliminado.
    let filteredRows = [];
    usuariosFiltrados.forEach(function (row) {
        //Activo
        if (activoFilter == true && bloqueadoFilter == false && eliminadoFilter == false) {
            if (row.Activo == true && row.Bloqueado == false) {
                filteredRows.push(row);
                LogHelper.Out(usuariosFilter.name, filteredRows);
                return;
            }
        }
        //Bloqueado
        if (activoFilter == false && bloqueadoFilter == true && eliminadoFilter == false) {
            if (row.Activo == false && row.Bloqueado == true) {
                filteredRows.push(row);
                LogHelper.Out(usuariosFilter.name, filteredRows);
                return;
            }
        }
        //Eliminado
        if (activoFilter == false && bloqueadoFilter == false && eliminadoFilter == true) {
            if (row.Activo == false && row.Bloqueado == false) {
                filteredRows.push(row);
                LogHelper.Out(usuariosFilter.name, filteredRows);
                return;
            }
        }
        //Activo y Bloqueado
        if (activoFilter == true && bloqueadoFilter == true && eliminadoFilter == false) {
            if ((row.Activo == true && row.Bloqueado == false) || (row.Activo == false && row.Bloqueado == true)) {
                filteredRows.push(row);
                LogHelper.Out(usuariosFilter.name, filteredRows);
                return;
            }
        }
        //Activo y Eliminado
        if (activoFilter == true && bloqueadoFilter == false && eliminadoFilter == true) {
            if ((row.Activo == true && row.Bloqueado == false) || (row.Activo == false && row.Bloqueado == false)) {
                filteredRows.push(row);
                LogHelper.Out(usuariosFilter.name, filteredRows);
                return;
            }
        }
        //Bloqueado y Eliminado
        if (activoFilter == false && bloqueadoFilter == true && eliminadoFilter == true) {
            if ((row.Activo == false && row.Bloqueado == true) || (row.Activo == false && row.Bloqueado == false)) {
                filteredRows.push(row);
                LogHelper.Out(usuariosFilter.name, filteredRows);
                return;
            }
        }
        //Activo, Bloqueado y Eliminado
        if (activoFilter == true && bloqueadoFilter == true && eliminadoFilter == true) {
            filteredRows.push(row);
            LogHelper.Out(usuariosFilter.name, filteredRows);
            return;
        }

        usuariosFiltrados = filteredRows;
    });

    //Filtro por columna y ejecuto el Sort en cada caso.
    if (column[columnIndex].state == true) {
        usuariosFiltrados = usuariosFiltrados.sort(function (a, b) {
            return sortArray(columnIndex, a, b, -1, 1);
        });
    } else {
        usuariosFiltrados = usuariosFiltrados.sort(function (a, b) {
            return sortArray(columnIndex, a, b, 1, -1);
        });
    }

    //Filtro por checkboxes seleccionados.
    usuariosFiltrados.forEach(function (item) {
        usuariosSeleccionados.forEach(function (item2) {
            if (item.Id == item2.Id)
                item.Seleccionado = true;
        })
    })

    LogHelper.Out(usuariosFilter.name, usuariosFiltrados);

    return usuariosFiltrados;
}

/**
 * Ordena la información de manera ascendente o descendente según los parametros recibidos.
 * @param {any} columnIndex - Indice que indica la columna de la tabla que fue clickeada.
 * @param {any} a
 * @param {any} b
 * @param {any} asc
 * @param {any} desc
 */
function sortArray(columnIndex, a, b, asc, desc) {
    LogHelper.In(sortArray.name);

    let firstRow = "";
    let SecondRow = "";
    switch (columnIndex) {
        case 0:
            firstRow = a.Nombre.toUpperCase();
            SecondRow = b.Nombre.toUpperCase();
            break;
        case 1:
            firstRow = a.Login.toUpperCase();
            SecondRow = b.Login.toUpperCase();
            break;
        case 2:
            firstRow = a.SUCURSAL.toUpperCase();
            SecondRow = b.SUCURSAL.toUpperCase();
            break;
        case 3:
            firstRow = a.SECTOR.toUpperCase();
            SecondRow = b.SECTOR.toUpperCase();
            break;
    }

    if (firstRow > SecondRow) {
        LogHelper.Out(sortArray.name, asc);
        return asc;
    }
    if (firstRow < SecondRow) {
        LogHelper.Out(sortArray.name, desc);
        return desc;
    }

    LogHelper.Out(sortArray.name);
    return 0;
}